import  './investment-portal.scss';
import template from './investment-portal.html';

import {ComponentBase} from "../../Common/componentBase";
import {RegisterDefaultComponent} from "../../Common/componentsHelpers";
import {AccountsService} from "../../Http/Accounts/AccountsService";
import {InvestmentPortalService} from "../../Http/InvestmentPortal/InvestmentPortalService";

const fundLineupDestination = '/fund-lineup';

function getAccountId() {
    const hashContents = decodeURIComponent(document.location.hash);
    const matches = hashContents.match(/account\/([0-9]+)/);
    return matches ? matches[matches.length - 1] : null;
}

function getPortalNavigation() {
    const hashContents = decodeURIComponent(document.location.hash || '');
    const [route, query] = hashContents.slice(1).split('?');
    const queryParams = new URLSearchParams(query);
    var backUrl = queryParams.get('backUrl');
    
    if (route === fundLineupDestination) {
        var dashboardPageName = $.cdh.routes.predefined.dashboard;
        return {
            destination: fundLineupDestination,
            backUrl: backUrl || `${dashboardPageName}`,
        };
    }

    backUrl = backUrl?.replace('#', "?");   // To support backUrl for account detailsHSA
    const destination = queryParams.get('destination');
    return {
        destination: destination === fundLineupDestination ? destination : null,
        backUrl,
    };
}

function getAccountSelectorUrl(destination, backUrl) {
    const selectorUrl = new URL(
        $.cdh.routes.predefined.investments.portalAccountSelector,
        document.location.origin,
    );
    if (destination) {
        selectorUrl.searchParams.set('destination', destination);
    }
    if (backUrl) {
        selectorUrl.searchParams.set('backUrl', backUrl);
    }

    return `${selectorUrl.pathname}${selectorUrl.search}`;
}

export class InvestmentPortalViewModel extends ComponentBase {
    constructor(params) {
        super(params);

        this.reloginRequired = ko.observable(false);
        this.accountId = getAccountId();
        const navigation = getPortalNavigation();
        this.destination = navigation.destination;
        this.backUrl = navigation.backUrl;
        this.accountLoaded = ko.observable(false);
        this.externalModel = null;

        if (!this.accountId) {
            document.location.href = getAccountSelectorUrl(this.destination, this.backUrl);
        } else {
            this.init();
        }
    }

    async init() {
        this.loading(true);
        this.error(false);

        const accountsService = new AccountsService();
        const investmentPortalService = new InvestmentPortalService();
        
        const result = await Promise.all([accountsService.byAccountIdAsync(this.accountId), investmentPortalService.getSettingsAsync()]);
        const account = result[0];
        const settingsResponse = result[1];

        if (this.destination) {
            const portalUrl = new URL(window.location.href);
            const backUrlQuery = this.backUrl ? `?backUrl=${encodeURIComponent(this.backUrl)}` : '';
            portalUrl.hash = `${this.destination}${backUrlQuery}`;
            window.history.replaceState(null, '', `${portalUrl.pathname}${portalUrl.search}${portalUrl.hash}`);
        }
        
        this.externalModel = {
            cacheBustInFileName: true,
            settings: settingsResponse?.data(),
            reloginRequired: this.reloginRequired,
            externalUrl: $.cdh.investmentPortalPath,
            payloadParams: {
                WcpUrl: `${document.location.protocol}//${document.location.host}`,
                AccountId: account.AccountId,
                FlexAccountId: account.FlexAcctId,
            },
            onError: () => {
                this.error(true);
            }
        };

        this.loading(false);
        this.accountLoaded(true);
    }
}
$.cdh.helper.updateHeightExternalApp('investment');
RegisterDefaultComponent('investment', template, InvestmentPortalViewModel);